module.exports = __webpack_public_path__ + "img/logo-inge-contacto.ab314835.svg";